<template>
  <!--
      作者 gmshop
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--添加门店-->
      <div class="common-form">商城设置</div>
      <el-form-item label="商城名称" :rules="[{required: true,message: ' '}]" prop="name">
        <el-input v-model="form.name" placeholder="商城名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="配送方式">
        <el-checkbox-group v-model="form.checkedCities">
          <el-checkbox v-for="(item,index) in all_type" :label="item.value" :key="index">{{item.name}}</el-checkbox>
         </el-checkbox-group>
        <div class="tips">注：配送方式至少选择一个</div>
      </el-form-item>
      <div class="common-form">日志记录</div>
      <el-form-item label="是否记录查询日志" prop="customer">
        <el-checkbox v-model="form.is_get_log">是否记录查询日志</el-checkbox>
        <div class="tips">如果记录，日志量会有点大</div>
      </el-form-item>
      <div class="common-form">商城下单记录轮播</div>
      <el-form-item label="是否显示下单轮播">
        <el-checkbox v-model="form.is_order_record">是否显示下单轮播</el-checkbox>
      </el-form-item>
      <div class="common-form">物流查询api</div>
      <el-form-item label="快递查询平台">
       <div>
         <el-radio v-model="form.delivery_platform" :label="0">快递100</el-radio>

         <el-radio v-model="form.delivery_platform" :label="10">快递鸟</el-radio>
       </div>
      </el-form-item>
      <div v-if="form.delivery_platform==0">
        <el-form-item label="快递100 Customer" :rules="[{required: true,message: ' '}]" prop="customer">
          <el-input v-model="form.customer" placeholder="" class="max-w460"></el-input>
          <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://www.kuaidi100.com/openapi/" target="_blank"
              type="primary">快递100申请</el-link>
          </div>
        </el-form-item>
        <el-form-item label="快递100 Key" :rules="[{required: true,message: ' '}]" prop="key">
          <el-input v-model="form.key" placeholder="" class="max-w460"></el-input>
        </el-form-item>
      </div>
      <div  v-if="form.delivery_platform==10">
          <el-form-item label="接口类型">
          <div>
            <el-radio v-model="form.api_type" :label="1002">免费版</el-radio>

            <el-radio v-model="form.api_type" :label="8001">付费版</el-radio>
            <div class="tips">
              免费版（仅支持圆通、申通、百世、天天）的查询（每天限量100）
            </div>
          </div>
          </el-form-item>
          <el-form-item label="快递鸟 ID" :rules="[{required: true,message: ' '}]" prop="id">
            <el-input v-model="form.id" placeholder="" class="max-w460"></el-input>
            <div class="tips">用于查询物流信息,<el-link :underline="false" href="https://www.kdniao.com" target="_blank"
                type="primary">快递鸟申请</el-link>
            </div>
          </el-form-item>
          <el-form-item label="快递鸟 apiKey" :rules="[{required: true,message: ' '}]" prop="apiKey">
            <el-input v-model="form.apiKey" placeholder="" class="max-w460"></el-input>
          </el-form-item>
      </div>
      <div class="common-form">用户协议设置</div>
      <el-form-item label="用户协议">
        <el-radio v-model="form.is_agree" :label="10">开启</el-radio>
        <el-radio v-model="form.is_agree" :label="20">关闭</el-radio>
      </el-form-item>
      <el-form-item label="协议内容" v-if="form.is_agree == 10 && !loading">
        <div class="edit_container">
          <Uediter v-model="form.agree_content" id="ue" :text="form.agree_content" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
<!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>

  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';
  import Upload from '@/components/file/Upload';
  import Uediter from '@/components/UE.vue';
  import { formatModel } from '@/utils/base.js';
  export default {
    components:{
      Upload,
      Uediter
    },
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          name: '',
          customer: '',
          key: '',
          id: '',
          apiKey: '',
          checkedCities: [],
          is_get_log: 0,
          delivery_platform: 0,
          api_type: 0,			
          is_order_record: 0,			
          is_agree: 10,
          agree_content: '',             
        },
        all_type: [],
        delivery_type: [],
        /*是否打开图片选择*/
        isupload:false,
        /*富文本配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        }
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.storeDetail({}, true).then(res => {
            let vars = res.data.vars.values;
            self.form = formatModel(self.form, vars);

            self.all_type = res.data.all_type;
            self.form.customer = vars.kuaidi100.customer;
            self.form.key = vars.kuaidi100.key;
            self.form.id = vars.kdniao.id;
            self.form.apiKey = vars.kdniao.apiKey;
            self.form.api_type = vars.kdniao.api_type;
            self.form.checkedCities = vars.delivery_type;
            self.form.delivery_platform = vars.delivery_platform;
            self.form.is_agree = vars.is_agree || self.form.is_agree;
            self.form.agree_content = vars.agree_content || self.form.agree_content;
            // 转成整数，兼容组件
            for(let i=0;i<self.form.checkedCities.length;i++){
              self.$set(self.form.checkedCities, i, parseInt(self.form.checkedCities[i]));
            }
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        if (self.form.is_agree == 10) {
          params.agree_content = this.$refs.ue.getUEContent();
        }
        if (params.checkedCities.length < 1) {
          self.$message({
            message: '配送方式至少选择一种！',
            type: 'warning'
          });
          return;
        }

        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.editStore(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你，商城设置成功',
                  type: 'success'
                });
                self.$router.push('/setting/store/index');
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue